import React, { useState } from "react";
import "./UserDeletionBtn.scss";
import { IonButton } from "@ionic/react";
import { CustomModalWeb } from "./CustomModalWeb";
import { clear, IONICWrapper } from "../../../utils/common";
import { useAuthService } from "../../../services/Auth";
import { LogIn } from "../../../models/home/login.model";
import { store } from "../../../store";
import { UserDeletionModel } from "../../../models/manage/user-deletion.model";
import { ToastMessage } from "../../../utils/ToastMessage";
import {
  USER_DELETION_UNSUCCESSFUL_MSG,
  DELETE_ACCOUNT_CONFIRMATION_TITLE,
  DELETE_ACCOUNT,
  DELETE_ACCOUNT_MESSAGE,
  DELETE_ACCOUNT_CONFIRMATION_MESSAGE,
  DELETE_ACCOUNT_MESSAGE_TITLE
} from "../../../utils/constants";
import { useDispatch } from "react-redux";
import { usrDeletionRequest } from "../../../actions/manage/action";
import { useTranslation } from "react-i18next";
import { logEvent } from "../../../utils/Analytics";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
const model: UserDeletionModel = new UserDeletionModel();

export const UserDeletionBtn = (props: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const dispatch = useDispatch();
  const authService = useAuthService();
  const { t } = useTranslation();
  const _clear = new LogIn();
  const logout = async () => {
    await clear();
    await authService.logout();
    _clear.clearToken();
    window.localStorage.clear();
    store.dispatch(logout());
  };
  const deleteModalProps = {
    title: (IONICWrapper.details.keys?.configuration.deleteAccount) || DELETE_ACCOUNT,
    message_header: (IONICWrapper.details.keys?.configuration.deleteAccountMessageTitle) || DELETE_ACCOUNT_MESSAGE_TITLE,
    message_content: (IONICWrapper.details.keys?.configuration.deleteAccountMessage) || DELETE_ACCOUNT_MESSAGE,
    buttons: [
      {
        title: t("Delete"),
        type: "secondary-cta-btn-web",
        onClick: () => {
          logEvent(EVENT.UE_ACCOUNT_DELETE_ATTEMPT, {
            screen: SCREEN.MP_EDIT_PROFILE
          });
          setIsModalOpen(false);
          setTimeout(() => {
            setIsAgreed(true);
          }, 1000);
        }
      },
      {
        title: t("Cancel"),
        type: "primary-cta-btn-web",
        onClick: () => {
          logEvent(EVENT.UE_DELETE_ACCOUNT_CANCEL, {
            screen: SCREEN.MP_EDIT_PROFILE
          });
        setIsModalOpen(false)
        }
      }
    ]
  };

  const deleteAndAgreedModalProps = {
    title: (IONICWrapper.details.keys?.configuration
          .deleteAccountConfirmationTitle) ||
      DELETE_ACCOUNT_CONFIRMATION_TITLE,
    message_header: (IONICWrapper.details.keys?.configuration
          .deleteAccountConfirmationMessage) ||
      DELETE_ACCOUNT_CONFIRMATION_MESSAGE,
    size: "small_height",
    buttons: [
      {
        title: t("Agree"),
        type: "secondary-cta-btn-web",
        onClick: async () => {
          setIsAgreed(false);
          dispatch(
            usrDeletionRequest({
              query: model.responseQuery(),
              callback: async (data: any) => {
                if (data && data.response && data.response.status === "200") {
                  logEvent(EVENT.UE_ACCOUNT_DELETE_SUCCESSFUL, {
                    screen: SCREEN.MP_EDIT_PROFILE
                  });
                  logout();
                  if(data.redirectUrl){
                   logEvent(EVENT.UE_DELETE_ACCOUNT_SURVEY, {
                    screen: SCREEN.DELETE_ACCOUNT_SURVEY_REDIRECTION
                  });
                  window.open(data.redirectUrl, "_blank");
                }
                } else {
                  await ToastMessage.show(USER_DELETION_UNSUCCESSFUL_MSG);
                }
              }
            })
          );
        }
      },
      {
        title: t("Disagree"),
        type: "primary-cta-btn-web",
        onClick: () => setIsAgreed(false)
      }
    ]
  };
  return (
    <div className="user-deletion-buttton-container">
      <IonButton
        onClick={() =>{
          logEvent(EVENT.UE_DELETE_ACCOUNT, {
            screen: SCREEN.MY_PROFILE_EDIT
          });
          setIsModalOpen(true)}}
        className="secondary-cta-btn-web"
        data-testid="dlt-btn"
      >
        <span>Delete Account</span>
      </IonButton>
      <CustomModalWeb isModalOpen={isModalOpen} {...deleteModalProps} />
      <CustomModalWeb isModalOpen={isAgreed} {...deleteAndAgreedModalProps} />
    </div>
  );
};
